"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMensagemCategoriaTipo = exports.EMensagemDestinatario = void 0;
var EMensagemDestinatario;
(function (EMensagemDestinatario) {
    EMensagemDestinatario[EMensagemDestinatario["Alunos"] = 0] = "Alunos";
    EMensagemDestinatario[EMensagemDestinatario["Respons\u00E1veis"] = 1] = "Respons\u00E1veis";
    EMensagemDestinatario[EMensagemDestinatario["Alunos e Respons\u00E1veis"] = 2] = "Alunos e Respons\u00E1veis";
    EMensagemDestinatario[EMensagemDestinatario["Logins extra do Aluno"] = 3] = "Logins extra do Aluno";
    EMensagemDestinatario[EMensagemDestinatario["Professores"] = 4] = "Professores";
})(EMensagemDestinatario = exports.EMensagemDestinatario || (exports.EMensagemDestinatario = {}));
var EMensagemCategoriaTipo;
(function (EMensagemCategoriaTipo) {
    EMensagemCategoriaTipo[EMensagemCategoriaTipo["Mensagens Gerais"] = 0] = "Mensagens Gerais";
    EMensagemCategoriaTipo[EMensagemCategoriaTipo["Conte\u00FAdo para avalia\u00E7\u00F5es"] = 1] = "Conte\u00FAdo para avalia\u00E7\u00F5es";
    EMensagemCategoriaTipo[EMensagemCategoriaTipo["Reuni\u00F5es"] = 2] = "Reuni\u00F5es";
    EMensagemCategoriaTipo[EMensagemCategoriaTipo["Tarefas de Casa"] = 3] = "Tarefas de Casa";
    EMensagemCategoriaTipo[EMensagemCategoriaTipo["Fotos"] = 4] = "Fotos";
})(EMensagemCategoriaTipo = exports.EMensagemCategoriaTipo || (exports.EMensagemCategoriaTipo = {}));
